module.exports = __webpack_public_path__ + "img/menu-board.42449759.png";